import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MARQUEE_ITEMS } from "../data/site";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono text-[10px] tracking-[0.3em] uppercase text-navy/70 flex items-center gap-3 ${className}`}>
    <span className="w-1.5 h-1.5 bg-ember inline-block" aria-hidden="true" />
    {children}
  </p>
);

export const Marker = ({ className = "" }) => (
  <span aria-hidden="true" className={`absolute w-2 h-2 bg-ember z-10 ${className}`} />
);

export const Marquee = () => {
  return (
    <div className="border-y border-linec bg-white py-4 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} aria-hidden={half === 1} className="flex shrink-0">
            {MARQUEE_ITEMS.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-mono text-[11px] tracking-[0.3em] text-dim whitespace-nowrap">
                <span className="px-6">{item}</span>
                <span className="text-ember">&#9679;</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export const BrowserFrame = ({ url, children, className = "" }) => (
  <div className={`rounded-lg border border-linec bg-white overflow-hidden ${className}`}>
    <div className="flex items-center gap-3 px-4 py-3 border-b border-linec bg-mist">
      <span className="flex gap-1.5">
        <span className="w-2.5 h-2.5 rounded-full bg-navy/15" />
        <span className="w-2.5 h-2.5 rounded-full bg-navy/15" />
        <span className="w-2.5 h-2.5 rounded-full bg-ember" />
      </span>
      <span className="font-mono text-[10px] tracking-wider text-dim truncate">{url}</span>
    </div>
    {children}
  </div>
);

const bracketInner = (primary, light, children) => {
  const tone = light ? "text-paper" : primary ? "text-ember" : "text-navy";
  return (
    <>
      <span className={`font-light text-[26px] leading-none flex items-center ${tone} transition-colors group-hover:text-white`}>[</span>
      <span className={`px-6 py-2.5 flex items-center text-sm ${tone} transition-colors group-hover:bg-ember group-hover:text-white`}>{children}</span>
      <span className={`font-light text-[26px] leading-none flex items-center ${tone} transition-colors group-hover:text-white`}>]</span>
    </>
  );
};

export const BracketLink = ({ to, href, children, primary = false, light = false, testid, className = "" }) => {
  const cls = `group inline-flex items-stretch font-body transition-colors ${className}`;
  return to
    ? <Link to={to} data-testid={testid} className={cls}>{bracketInner(primary, light, children)}</Link>
    : <a href={href || "#"} data-testid={testid} className={cls}>{bracketInner(primary, light, children)}</a>;
};

export const BracketButton = ({ onClick, children, primary = true, light = false, testid, className = "", disabled = false }) => (
  <button onClick={onClick} disabled={disabled} data-testid={testid}
    className={`group inline-flex items-stretch font-body transition-colors disabled:opacity-50 ${className}`}>
    {bracketInner(primary, light, children)}
  </button>
);
